import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, Input, Space } from "antd";
import { useRef, useState } from "react";
import { PatternFormat } from "react-number-format";
import K from "utilities/constants";
import { validateMobileNumber } from "utilities/generalUtility";
import { CandidateFieldLabel } from "../candidateFieldLabel/candidateFieldLabel";
import labelStyles from "../candidateFieldLabel/candidateFieldLabel.module.scss";
import { CandidateFieldValue } from "../candidateFieldValue/candidateFieldValue";

export const CandidatePhoneField = ({
  label,
  value,
  isEditable = false,
  disabled = false,
  onEdit,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [validationError, setValidationError] = useState(null);
  const inputRef = useRef(value);

  const handleSave = () => {
    const next = inputRef.current || null;
    if (next && !validateMobileNumber(next)) {
      setValidationError("Please enter correct number");
      return;
    }
    setValidationError(null);
    if (next !== value) onEdit?.(next);
    setIsEdit(false);
  };

  const handleCancel = () => {
    inputRef.current = value;
    setValidationError(null);
    setIsEdit(false);
  };

  if (isEdit) {
    return (
      <div>
        <CandidateFieldLabel>{label}</CandidateFieldLabel>
        <PatternFormat
          defaultValue={value ?? ""}
          customInput={Input}
          format={K.PhoneFormat.USNational}
          style={{ width: "100%" }}
          status={validationError ? "error" : undefined}
          onValueChange={({ value: val }) => {
            inputRef.current = val || null;
          }}
        />
        {validationError && (
          <div className={labelStyles.errorMessage}>
            {validationError}
          </div>
        )}
        <div style={{ marginTop: 4 }}>
          <Button
            type="link"
            onClick={handleCancel}
            icon={<CloseCircleOutlined className="closeIcon" />}
          />
          <Button
            type="link"
            onClick={handleSave}
            icon={<CheckCircleOutlined className="checkIcon" />}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <CandidateFieldLabel>{label}</CandidateFieldLabel>
      <Space size={4} style={{ minHeight: 24 }}>
        <CandidateFieldValue>
          {value ? (
            <PatternFormat
              value={value}
              format={K.PhoneFormat.USNational}
              displayType="text"
            />
          ) : (
            K.NullPlaceholder
          )}
        </CandidateFieldValue>
        {isEditable && !disabled && (
          <Button
            style={{ width: 16, height: 16 }}
            type="link"
            onClick={() => {
              inputRef.current = value;
              setIsEdit(true);
            }}
            icon={<i className="icon-edit" />}
          />
        )}
      </Space>
    </div>
  );
};
